export const privacyTranslations = {
  PRIVACY_TITLE: 'Privact Statement',
  PRIVACY_SUBTITLE: 'version',
};
